<template>
  <section class="home">
    <nav data-aos="fade-down" :class="['navbar navbar-expand-md hidden', { sticky: isSticky }]">
      <div class="container transition-mode-bg">
        <svg class="svg left transition-mode-color" width="22" height="26" viewBox="0 0 22 26"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0.931314 0.736328H21.6426V25.1321C21.2863 9.29344 15.6873 1.4416 0.931314 0.736328Z"
            fill="currentColor" />
        </svg>
        <svg class="svg right transition-mode-color" width="22" height="26" viewBox="0 0 22 26"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0.931314 0.736328H21.6426V25.1321C21.2863 9.29344 15.6873 1.4416 0.931314 0.736328Z"
            fill="currentColor" />
        </svg>
        <router-link class="navbar-brand" to="/">
          <MgrLogoComponent />
        </router-link>
        <div class="toggle-collapse">
          <button class="toggle-mode-sm d-md-none d-flex" @click="toggleTheme">
            <i :class="theme === 'dark'
              ? 'ti ti-toggle-left-filled'
              : 'ti ti-toggle-right-filled'
              "></i>
          </button>
          <button class="navbar-toggler" :class="[{ open: isopen }]" type="button" data-bs-toggle="collapse"
            data-bs-target="#menuItems" aria-controls="menuItems" :aria-expanded="isExpanded"
            aria-label="Toggle navigation" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div class="collapse navbar-collapse" id="menuItems">
          <ul class="navbar-nav ms-auto gap-2">
            <p class="title-menu-nav d-md-none d-flex">MENU</p>
            <svg class="d-md-none d-flex" width="300" height="141" viewBox="0 0 300 141" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6 0.786621C2.68555 0.786621 0 3.47314 0 6.78662V134.787C0 138.1 2.68555 140.787 6 140.787H294C297.314 140.787 300 138.1 300 134.787V49.7866C300 46.4729 297.314 43.7866 294 43.7866H220C216.686 43.7866 214 41.1003 214 37.7866V6.78662C214 3.47291 211.314 0.786621 208 0.786621H6Z"
                fill="currentColor" />
            </svg>

            <li class="nav-item" @mouseenter="enterCard" @mouseleave="leaveCard">
              <div class="framer-epfdzp" style=""></div>
              <router-link class="nav-link transition-mode-color" exact-active-class="active" to="/">
                <span class="btn-text-one">Home</span>
                <span class="btn-text-two">Home</span>
              </router-link>
            </li>
            <li class="nav-item" @mouseenter="enterCard" @mouseleave="leaveCard">
              <router-link class="nav-link transition-mode-color" exact-active-class="active" to="/Careers">
                <span class="btn-text-one">Careers</span>
                <span class="btn-text-two">Careers</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- begin hero section -->
    <div class="hero-section">
      <div class="container" :style="{ maxWidth: containerWidth }">
        <div class="hero-text" :style="{
          width: widthContainer,
        }">
          <h1 class="title" :style="{ fontSize: titleFontSize }">
            CV. MULTI GRAHA RADHIKA
          </h1>
          <p class="description" :style="{ fontSize: descriptionFontSize }">
            Kami adalah perusahaan yang berawal dari startup kecil di bidang
            software dan website, kini berkembang menjadi penyedia solusi
            teknologi untuk pasar global.
          </p>
        </div>
        <div class="img">
          <img :src="require(`@/assets/img/${theme === 'dark' ? 'hero-dark.png' : 'hero.png'
            }`)
            " alt="Hero Image" />
          <div class="overlay-hero"></div>
          <div class="badge city transition-mode-bg-border">Purwakarta</div>
          <div class="badge time transition-mode-bg-border">
            {{ currentTime }}
          </div>
        </div>
      </div>
    </div>
    <!-- end hero section -->
    <div class="body-content">
      <div class="container">
        <div class="content">
          <!--begin logo brand -->
          <div class="brand">
            <div class="logos" :class="{ 'center-logos': brand.length < 4 }">
              <div class="logo_items" v-for="(logos, index) in displayLogos" :key="index"
                :class="{ 'no-animation': brand.length < 4 }">
                <img class="transition-mode-filter" v-for="logo in logos" :key="logo.id"
                  :src="`${BASE_URL}/${logo.logo}`" alt="Brand Logo" />
              </div>
            </div>
          </div>
          <!-- end logo brand -->
          <!-- begin product list -->

          <div class="product">
            <div class="title">
              <img src="@/assets/img/title_product.png" alt="" />
            </div>
            <div class="product_list mb-5">
              <div class="row row-cols-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-2">
                <div class="col" v-for="product in product_list" :key="product.id">
                  <div class="card transition-mode-bg-border" @mousemove="moveButton" @mouseenter="enterCard"
                    @mouseleave="leaveCard">
                    <div class="card-content">
                      <div class="img-brand">
                        <img class="transition-mode-filter" :src="`${BASE_URL}/${product.logo}`" alt="" />
                      </div>
                      <p class="title-brand transition-mode-color">{{ product.name }}</p>
                      <div class="desc-brand transition-mode-color">
                        {{ product.description }}
                      </div>
                      <div class="contentBtn">
                        <a v-if="product.url" :href="product.url" target="_blank" class="btn btn-show-sm"><i
                            class="ti ti-world-www fs-6"></i>
                          Website
                        </a>
                      </div>
                    </div>
                    <div class="framer-uu6fzr"></div>
                    <a v-if="product.url" :href="product.url" target="_blank" class="btn btn-view"
                      ref="btnView">Website</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end product list -->
        </div>
      </div>
    </div>
    <!-- begin our partners -->
    <div class="partners">
      <div class="container">
        <div class="content">
          <div class="title">
            <img src="@/assets/img/title_partners.png" alt="" />
          </div>
          <div class="brand mt-5">
            <div class="logos top">
              <div class="logo_items" v-for="n in 4" :key="`logo_items_${n}`">
                <img v-for="(image, index) in titleImages" :key="`image_${index}_${n}`"
                  :src="require(`@/assets/img/${image}`)" alt="Title Image" />
              </div>
            </div>
            <div class="logos bottom">
              <div class="logo_items" v-for="n in 4" :key="`logo_items_${n}`">
                <img v-for="(image, index) in titleImages" :key="`image_${index}_${n}`"
                  :src="require(`@/assets/img/${image}`)" alt="Title Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end our partners -->

    <div class="body-content about-miss">
      <div class="container">
        <div class="content">
          <div class="title">
            <img src="@/assets/img/title_about.png" alt="" />
          </div>
          <div class="cards">
            <!-- begin content about -->
            <div class="card about ">
              <p class="detail">Didirikan pada 28 Juli 2021, CV Multi Graha Radhika memulai perjalanan sebagai startup
                kecil yang fokus
                pada pembuatan software dan website. Dengan dedikasi terhadap inovasi dan kualitas, kami berkembang
                menjadi penyedia solusi teknologi yang melayani kebutuhan global. Kami bangga menghadirkan produk andal,
                aman, dan mudah digunakan untuk pelanggan kami di berbagai industri.</p>
              <div class="keyPoint">
                <div>
                  <i class="ti ti-calendar-filled transition-mode-color"></i>
                  <p>
                    <span class="fw-bold">Berdiri Sejak:</span>
                    <span>2021</span>
                  </p>
                </div>
                <div>
                  <i class="ti ti-world-code transition-mode-color"></i>
                  <p>
                    <span class="fw-bold">Bidang:</span>
                    <span>Software Development, Website Creation, Teknologi
                      Inovatif.</span>
                  </p>
                </div>
                <div>
                  <i class="ti ti-caret-up-filled transition-mode-color"></i>
                  <p>
                    <span class="fw-bold">Visi:</span>
                    <span>Menjadi penyedia solusi teknologi terpercaya dengan
                      produk inovatif dan andal.</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- end content about -->
            <!-- begin content mission -->
            <div class="row mission row-cols-1 row-cols-md-2 g-2">
              <div class="col" v-for="(item, index) in missionItems" :key="index">
                <div class="card">
                  <div class="icon">
                    <i :class="item.icon"></i>
                  </div>
                  <p class="title-mission">{{ item.title }}</p>
                  <p class="desc-mission">{{ item.text }}</p>
                </div>
              </div>
            </div>
            <!-- end  content mission -->
          </div>
        </div>
      </div>
    </div>
    <!-- begin background gradient footer -->
    <div class="bg-footer">
      <div class="content">
        <div class="footer-gradient"></div>
        <img src="@/assets/img/illustration.png" alt="" />
      </div>
    </div>
    <!-- end background gradient footer -->
  </section>
</template>

<script>
import { BASE_URL } from "@/config";
import { EventBus } from "@/EventBus";
import moment from "moment-timezone";
import api from "@/api";
import MgrLogoComponent from "@/components/MgrLogoComponent.vue";
import { toggleMixin } from "@/mixins/toggleMixin";
export default {
  components: { MgrLogoComponent },
  name: "HomeView",
  mixins: [toggleMixin],
  data() {
    return {
      BASE_URL,
      isSticky: false,
      isExpanded: false,
      isopen: false,
      containerWidth: "1500px",
      titleFontSize: "102px",
      descriptionFontSize: "22px",
      widthContainer: "80%",
      currentTime: this.getCurrentTime(),
      brand: [],
      product_list: [],
      smoothButtonX: 0,
      smoothButtonY: 0,
      isCursorInsideCard: false,
      titleImages: Array(5).fill("logo_borneo.png"),
      theme: localStorage.getItem("theme") || "light",
      missionItems: [
        {
          icon: "ti ti-bulb-filled",
          title: "Inovasi",
          text: "Mengembangkan solusi teknologi yang inovatif dan andal.",
        },
        {
          icon: "ti ti-headphones-filled",
          title: "Pelayanan",
          text: "Memberikan layanan pelanggan yang responsif dan ramah.",
        },
        {
          icon: "ti ti-circle-arrow-up-right-filled",
          title: "Kualitas",
          text: "Berkomitmen untuk terus meningkatkan kualitas produk dan layanan.",
        },
        {
          icon: "ti ti-affiliate-filled",
          title: "Kolaborasi",
          text: "Mengidentifikasi peluang kolaborasi dan kemitraan strategis.",
        },
      ],
    };
  },

  computed: {
    displayLogos() {
      return this.brand.length >= 4 ? Array(4).fill(this.brand) : [this.brand];
    },
  },
  mounted() {
    EventBus.$on("themeChanged", (theme) => (this.theme = theme));
    window.addEventListener("scroll", this.handleScroll);
    this.timeInterval = setInterval(this.updateTime, 1000);
    this.getBrand();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.timeInterval);
  },
  methods: {
    moveButton(event) {
      if (this.isCursorInsideCard) {
        const cardRect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - cardRect.left;
        const y = event.clientY - cardRect.top;

        this.smoothButtonX += (x - this.smoothButtonX) * 0.1;
        this.smoothButtonY += (y - this.smoothButtonY) * 0.1;

        const btn = event.currentTarget.querySelector(".btn-view");
        if (btn) {
          btn.style.left = `${this.smoothButtonX}px`;
          btn.style.top = `${this.smoothButtonY}px`;
        }

        const centerX = cardRect.width / 2;
        const centerY = cardRect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -15;
        const rotateY = ((x - centerX) / centerX) * 15;

        event.currentTarget.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      }
    },

    enterCard(event) {
      this.isCursorInsideCard = true;
      event.currentTarget.style.transition = "none";
      this.$emit("cursor-enter", false);
    },
    leaveCard(event) {
      this.isCursorInsideCard = false;
      event.currentTarget.style.transition = "transform 0.4s ease";
      event.currentTarget.style.transform =
        "perspective(1000px) rotateX(0deg) rotateY(0deg)";
      this.$emit("cursor-enter", true);
    },

    async getBrand() {
      try {
        const response = await api.get("Landing/product");
        this.brand = response.data.data;
        this.product_list = this.brand;

      } catch (error) {
        // console.error('Error fetching data:', error);
      }
    },

    handleScroll() {
      this.isSticky = window.scrollY > 20;
      if (window.innerWidth > 1200) {
        this.containerWidth = window.scrollY > 0 ? "1200px" : "1500px";
        this.titleFontSize = window.scrollY > 0 ? "66px" : "102px";
        this.descriptionFontSize = window.scrollY > 0 ? "16px" : "22px";
        this.widthContainer = window.scrollY > 0 ? "55%" : "80%";
      }
    },

    getCurrentTime() {
      const time = moment.tz("Asia/Jakarta");
      const gmtOffset = time.utcOffset() / 60;
      const gmtString = `GMT${gmtOffset >= 0 ? "+" : "-"}${Math.abs(
        gmtOffset
      )}`;

      return `${time.format("HH:mm:ss")} ${gmtString}`;
    },
    updateTime() {
      this.currentTime = this.getCurrentTime();
    },
  },
};
</script>
